<div class="child-accordion">
  <nz-collapse [nzGhost]="true" [nzBordered]="false">
    @for (question of questions; track question) {
      <nz-collapse-panel
        [id]="question.id"
        [nzHeader]="headerTemplate"
        [nzActive]="question.active"
        (nzActiveChange)="onActiveChange(question)"
      >
        <ng-template #headerTemplate>
          <div class="flex flex-col gap-2 justiy-start items-start">
            <span class="paragraph-medium outfit header font-medium accordion-header">
              {{ question.question | translate }}
            </span>
          </div>
        </ng-template>
        <p class="font-light outfit paragraph-medium block">
          {{ question.answer | translate }}
        </p>
        <!-- do not delete this ngIf, because otherwise absolutely all videos from all sections start to load -->
        @if (!!question.active && !!question?.video_id) {
          <app-youtube-video class="mt-5 md:mt-7 lg:mt-7 block" [videoId]="question?.video_id"></app-youtube-video>
        }
      </nz-collapse-panel>
    }
  </nz-collapse>
</div>
